import { Injectable, Inject } from '@angular/core'
import { of, Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { catchError } from 'rxjs/operators'

@Injectable()
export class PackageService {
  constructor(private httpClient: HttpClient) {}

  getPlanGroup(): Observable<any> {
    // local
    // const endpoint = 'https://flowaccountcdn.com/new_landing/data/pricing-list-mock/top-version-plan-mock-2.json'

    // staging
    // const endpoint = 'https://6lsygkrb52.execute-api.ap-southeast-1.amazonaws.com/dev/subscription/top-version-plan'

    // production
    const endpoint = 'https://pwvm06l7wh.execute-api.ap-southeast-1.amazonaws.com/prod/subscription/top-version-plan'

    return this.httpClient.get<any>(endpoint).pipe(
      catchError((err) =>
        of({
          status: false,
          message: err.message,
        }),
      ),
    )
  }
}
